<div class="tabs is-boxed is-medium">
  <ul>
    <li [class.is-active]="activeTab === 'info'">
      <a (click)="navigateTo.emit('itinerary/info')">
        <span class="weight-medium">{{ 'options.info' | translate }}</span>
      </a>
      <div *ngIf="activeTab === 'info'" class="inner">&nbsp;</div>
    </li>

    <li [class.is-active]="activeTab === 'history'">
      <a (click)="navigateToHistory()">
        <span class="weight-medium">{{
          'breadcrumb.history' | translate
        }}</span>
      </a>
      <div *ngIf="activeTab === 'history'" class="inner">&nbsp;</div>
    </li>
    
    <li [class.is-active]="activeTab === 'itineraryHistory'">
      <a (click)="navigateToItineraryHistory()">
        <span class="weight-medium">{{
          'breadcrumb.itineraryHistory' | translate
        }}</span>
      </a>
      <div *ngIf="activeTab === 'itineraryHistory'" class="inner">&nbsp;</div>
    </li>

    <li *ngIf="showAirlineNotes" [class.is-active]="activeTab === 'airCompanyNotes'">
      <a (click)="navigateToAirCompanyNotes()">
        <span class="weight-medium">{{
          'breadcrumb.airCompanyNotes' | translate
        }}</span>
      </a>
      <div *ngIf="activeTab === 'airCompanyNotes'" class="inner">&nbsp;</div>
    </li>

    <li [class.is-active]="activeTab === 'ticketHistory'">
      <a (click)="navigateToTicketHistory()">
        <span class="weight-medium">{{
          'options.history-ticket' | translate
        }}</span>
      </a>
      <div *ngIf="activeTab === 'ticketHistory'" class="inner">&nbsp;</div>
    </li>

    <li [class.is-active]="activeTab === 'log'">
      <a (click)="navigateTo.emit('itinerary/operation-log')">
        <span class="weight-medium">{{
          'options.operations-register' | translate
        }}</span>
      </a>
      <div *ngIf="activeTab === 'log'" class="inner">&nbsp;</div>
    </li>
  </ul>
</div>
